import React from "react";
import GamesSec from "./GamesSec";
import GamingStats from "./GamingStats";
import Footer from "../common/Footer";
import Header from "../common/header";
import Banner from "./SportsDraftBanner";
import SportsDraftByGamerji from "../component/Number";
import SportsDraftAuction from "./SportsDraftAuction";
import SportsDraftPicker from "./SportsDraftPicker";
const SportsDraft: React.FC = () => {
  return (
    <div className="w-full h-full">
      <Header />
      <Banner />
      <SportsDraftAuction />
      <GamesSec />
       <SportsDraftPicker />
      <GamingStats />
      <SportsDraftByGamerji />
     
      <Footer />
    </div>
  );
};

export default SportsDraft;
